import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import SellReportFormConfig from "./form";
import { Button, Col, Row } from "reactstrap";
import { getYearBoundaries } from "@utils/Utils";
import { SellReportFormDataType } from "@/formTypes/SellReportFormDataType";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type SellYearReportFormProps = {
}

const SellYearReportForm = forwardRef<DynamicFormRef, SellYearReportFormProps>(
  (props, ref) => {
    const formRef = useRef<DynamicFormRef>(null);
    const [clientId, setClientId] = useState<string>("-2");

    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      formRef.current?.resetFormValue({
        clientId: "-2",
        zoneId: "-2",
        year,
        includeSettlements: false,
      })
    }, [])

    const formConfig = useMemo(() => {
      return {
        ...SellReportFormConfig,
        sections: SellReportFormConfig.sections.map((section) => ({
          ...section,
          fields: section.fields.map((row) =>
            row.map((field) => {
              if (field.name === "clientId") {
                return {
                  ...field,
                  onChangePubSub: (value: string) => {
                    setClientId(value);
                    if (value === "-2") {
                      formRef.current?.setFormValue("includeSettlements", false, "checkbox");
                    }
                  },
                };
              }
              if (field.name === "includeSettlements") {
                return {
                  ...field,
                  visibilityHiddenIf: () => clientId === "-2",
                };
              }
              return field;
            })
          ),
        })),
      };
    }, [clientId]);

    const generateForm = (formData: SellReportFormDataType) => {
      const { startDate, endDate } = getYearBoundaries(`${formData.year}`)
      const includeSettlementsFlag = formData.clientId !== "-2" && formData.includeSettlements ? "1" : "0";
      const autoPrint = "0";
      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/sellByPeriod/${formData.clientId}/${formData.zoneId}/${startDate}/${endDate}/${autoPrint}/${includeSettlementsFlag}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        const detallarIva = formData.detallarIva ? "1" : "0";
        window.open(`/user/reports/excel/sellByPeriod/${formData.clientId}/${formData.zoneId}/${startDate}/${endDate}/${detallarIva}/${autoPrint}/${includeSettlementsFlag}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<SellReportFormDataType>
          ref={formRef}
          id="report"
          formConfig={formConfig}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Report</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default SellYearReportForm;